<template>
  <div :ref="formRef"
       class="zahlweise--form">

    <div class="section">
      <v-row no-gutters>

        <v-col cols="12"
               sm="3">
          <label class="dmb-form-text">Zahlungsart*
          </label>
        </v-col>

        <v-col cols="12"
               sm="9">
          <v-radio-group v-model="rechnungszahler"
                         v-validate="'required'"
                         :error-messages="errors.collect('rechnungszahler')"
                         :class="$vuetify.breakpoint.xsOnly ? '' : 'pt-0' "
                         data-vv-as="Rechnungszahler"
                         data-vv-name="rechnungszahler"
                         name="rechnungszahler"
                         class="rechnungszahler-rb no-errors-group"
                         row>
            <v-radio :class="$vuetify.breakpoint.xsOnly ? 'pt16' : '' "
                     label="SEPA-Lastschrift-Mandat"
                     value="N"
                     color="primary" />
            <v-radio :class="$vuetify.breakpoint.xsOnly ? 'pt16' : '' "
                     offset-md="3"
                     label="Rechnung"
                     value="J"
                     color="primary" />
            <v-radio v-if="maklerinkassoAllowed" 
                     :class="$vuetify.breakpoint.xsOnly ? 'pt16' : '' "
                     label="Maklerinkasso"
                     value="M"
                     color="primary" />
          </v-radio-group>
        </v-col>

      </v-row>

    </div>

    <bank-verbindung v-if="rechnungszahler === 'N'"
                     state-path="editContract"
                     form-ref="konto-form" />

  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import BankVerbindung from "@/components/privatkundenrechner/Bankverbindung.vue";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import { RIGHTS } from '@/store/user';

export default {
  components: { BankVerbindung },
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  props: {
    formRef: {
      type: String,
      required: true
    },
    sensibleDefaults: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    maklerinkassoAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.MAKLERINKASSO);
    },
    ...mapTwoWay([
      "rechnungszahler"
    ])
  },
  methods: {}
};
</script>

<style>
.zahlweise--form .section {
  margin-bottom: -16px !important;
  overflow: auto;
}

.zahlweise--form .pt16 {
  padding: 16px 0 0 0 !important;
}

.zahlweise--form .dmb-form-text {
  font-size: 16px;
}

.zahlweise--form .rechnungszahler-rb .input-group {
  padding-top: 0 !important;
  max-width: unset;
}
</style>

